import React, { useRef } from 'react';
import { theme } from '../../../theme';
import { useEChartsLifecycle, STD_TOOLTIP_STYLE, makeCountTooltipFormatter } from './_chartCommon';

// <purpose>Tag.Verlauf — smooth area chart, tooltip-only (no per-point labels).</purpose>

type Props = {
  data: Array<{ date: string; count: number }>;
  filterHash?: string;
};

export const TagVerlauf: React.FC<Props> = ({ data, filterHash }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const NAVY = theme.colors.navy;

  useEChartsLifecycle(containerRef, chart => {
    chart.setOption({
      grid: { left: 36, right: 16, top: 24, bottom: 26 },
      tooltip: {
        ...STD_TOOLTIP_STYLE,
        trigger: 'axis',
        axisPointer: { type: 'line', lineStyle: { color: NAVY, opacity: 0.35, width: 1 } },
        formatter: makeCountTooltipFormatter(NAVY),
      },
      xAxis: {
        type: 'category',
        data: data.map(d => d.date),
        axisLine: { lineStyle: { color: '#dde0e8' } },
        axisTick: { show: false },
        axisLabel: { color: '#9095a3', fontSize: 8, interval: Math.max(0, Math.floor(data.length / 8) - 1) },
      },
      yAxis: {
        type: 'value',
        splitLine: { lineStyle: { color: '#f1f2f6' } },
        axisLabel: { color: '#9095a3', fontSize: 9 },
        axisLine: { show: false },
        axisTick: { show: false },
      },
      series: [{
        type: 'line',
        data: data.map(d => d.count),
        smooth: 0.45,
        symbol: 'circle',
        symbolSize: 4,
        showSymbol: false,
        itemStyle: { color: 'white', borderColor: NAVY, borderWidth: 1.5 },
        lineStyle: { color: NAVY, width: 1.5 },
        areaStyle: {
          color: {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(6,16,90,0.18)' },
              { offset: 1, color: 'rgba(6,16,90,0.01)' },
            ],
          },
        },
        emphasis: {
          scale: 1.6,
          itemStyle: { color: NAVY, borderColor: 'white', borderWidth: 2, shadowColor: 'rgba(6,16,90,0.45)', shadowBlur: 10 },
        },
      }],
    });
  }, [data, filterHash]);

  return <div ref={containerRef} style={{ width: '100%', height: 220 }} />;
};
